import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FrictionPage } from '../screens/admin/FrictionPage';
import { periodSearch } from '../screens/admin/period-search';

const searchSchema = z.object({
  ...periodSearch,
  /** The kind whose last ten are open. */
  kind: z
    .enum([
      'request.failed',
      'browser.error',
      'scan.failed',
      'pages.upload_failed',
      'export.failed',
      'review.withdrawn',
    ])
    .optional(),
});

export const Route = createFileRoute('/admin/friction')({
  validateSearch: searchSchema,
  component: FrictionPage,
});
